"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserType = exports.isDeidentified = exports.IdentifyingFields = void 0;
exports.IdentifyingFields = [
    'email',
    'firstName',
    'lastName',
    'phoneNumber',
    'displayName',
    'aboutMe',
    'photoURL',
    'address',
    'address2',
    'city',
    'state',
    'zip',
    'pronouns',
];
const isDeidentified = (user) => user.deidentified === true; // Force boolean check since property is optional
exports.isDeidentified = isDeidentified;
var UserType;
(function (UserType) {
    UserType["Business"] = "Business";
    UserType["Consumer"] = "Consumer";
    UserType["PlatformAdmin"] = "PlatformAdmin";
})(UserType || (exports.UserType = UserType = {}));
